import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  routes: [
        {
            path: '/',
            name: 'login',
            component: () => import('../components/view/main/login')
        },
        {
            path: '/login',
            name: 'login1',
            component: () => import('../components/view/main/login')
        },
        {
            path: '/hello',
            name: 'HelloWorld',
            component: HelloWorld
        },
        {
            path: '/main',
            name: 'main',
            component: () => import('../components/view/main/main2'),
            children: [
                {
                    path: '/test',
                    name: 'test',
                    component: () => import('@/components/view/test/test')
                },
                {
                    path: '/user',
                    name: 'user',
                    component: () => import('@/components/view/sys/sysUser'),
                    meta: {
                        title: '员工管理'
                    }
                },{
                    path: '/updatepwd',
                    name: 'updatepwd',
                    component: () => import('@/components/view/sys/updatePassword'),
                    meta: {
                        title: '修改密码'
                    }
                },{
                    path: '/updateAvatar',
                    name: 'updateAvatar',
                    component: () => import('@/components/view/sys/updateAvatar'),
                    meta: {
                        title: '员工头像'
                    }
                },
                 {
                    path: '/role',
                    name: 'role',
                    component: () => import('@/components/view/sys/sysRole'),
                    meta: {
                        title: '角色管理'
                    }
                },
                {
                    path: '/menu',
                    name: 'menu',
                    component: () => import('@/components/view/sys/sysMenu'),
                    meta: {
                        title: '菜单管理'
                    }
                },
                  {
                    path: '/qyDeptment',
                    name: 'qyDeptment',
                    component: () => import('@/components/view/qy/qyDeptment'),
                    meta: {
                        title: '企业通讯录'
                    }
                },
                  {
                    path: '/customer',
                    name: 'customer',
                    component: () => import('@/components/view/customer/customer/customer'),
                    meta: {
                        title: '客户信息'
                    }
                },
                  {
                    path: '/customerDetail',
                    name: 'customerDetail',
                    component: () => import('@/components/view/customer/customer/customer_detail'),
                    meta: {
                        title: '客户信息详情'
                    }
                }, {
                    path: '/customerTz',
                    name: 'customerTz',
                    component: () => import('@/components/view/customer/customertz/customer_tz'),
                    meta: {
                        title: '市场拓展'
                    }
                },
                  {
                    path: '/customerTzDetail',
                    name: 'customerTzDetail',
                    component: () => import('@/components/view/customer/customertz/customer_tz_detail'),
                    meta: {
                        title: '市场拓展详情'
                    }
                },{
                    path: '/customerYy',
                    name: 'customerYy',
                    component: () => import('@/components/view/customer/customeryy/customer_yy'),
                    meta: {
                        title: '客户信息-已有客户'
                    }
                },
                  {
                    path: '/customerYyDetail',
                    name: 'customerYyDetail',
                    component: () => import('@/components/view/customer/customerYy/customer_yy_detail'),
                    meta: {
                        title: '客户信息-已有客户详情'
                    }
                },
                {
                    path: '/serviceSubtype',
                    name: 'serviceSubtype',
                    component: () => import('@/components/view/service/servicesubtype/serviceSubtype'),
                    meta: {
                        title: '服务信息-服务小类'
                    }
                },
                {
                    path: '/serviceRatio',
                    name: 'serviceRatio',
                    component: () => import('@/components/view/service/serviceratio/serviceRatio'),
                    meta: {
                        title: '服务信息-服务汇率'
                    }
                },
                {
                    path: '/serviceItem',
                    name: 'serviceItem',
                    component: () => import('@/components/view/service/serviceitem/serviceItem'),
                    meta: {
                        title: '服务信息-服务细分项'
                    }
                },
                 {
                    path: '/serviceInfo',
                    name: 'serviceInfo',
                    component: () => import('@/components/view/service/serviceinfo/serviceInfo'),
                    meta: {
                        title: '服务项目'
                    }
                },
                {
                    path: '/project',
                    name: 'project',
                    component: () => import('@/components/view/project/project'),
                    meta: {
                        title: '服务项目'
                    }
                },
                {
                    path: '/stock',
                    name: 'stock',
                    component: () => import('@/components/view/stock/stock'),
                    meta: {
                        title: '股票'
                    }
                },
                {
                    path: '/stockItem',
                    name: 'stockItem',
                    component: () => import('@/components/view/stock/stock_item'),
                    meta: {
                        title: '做T明细'
                    }
                },
                {
                    path: '/contract',
                    name: 'contract',
                    component: () => import('@/components/view/contract/contract'),
                    meta: {
                        title: '合同管理'
                    }
                },
                {
                    path: '/contractDetail',
                    name: 'contractDetail',
                    component: () => import('@/components/view/contract/contract_detail'),
                    meta: {
                        title: '合同管理详情'
                    }
                },
                {
                    path: '/contractService',
                    name: 'contractService',
                    component: () => import('@/components/view/contract/contractservice/contract_service'),
                    meta: {
                        title: '合同服务项'
                    }
                },
                {
                    path: '/contractServiceCard',
                    name: 'contractServiceCard',
                    component: () => import('@/components/view/contract/component/contractServiceCard'),
                    meta: {
                        title: '合同服务项-卡片'
                    }
                },
                 {
                    path: '/adviser',
                    name: 'adviser',
                    component: () => import('@/components/view/adviser/adviser')
                },
                {
                    path: '/xsfx',
                    name: 'xsfx',
                    component: () => import('@/components/view/xsfx/xsfx'),
                    meta: {
                        title: '用户智能画像'
                    }
                },
                {
                    path: '/kpi',
                    name: 'kpi',
                    component: () => import('@/components/view/kpi/kpi'),
                    meta: {
                        title: 'kpi'
                    }
                },
                {
                    path: '/qkpy',
                    name: 'qkpy',
                    component: () => import('../components/view/qkpy/qkpy'),
                    meta: {
                        title: '潜客培育效果分析'
                    }
                },
                {
                    path: '/sjrb',
                    name: 'sjrb',
                    component: () => import('../components/view/sjrb/sjrb'),
                    meta: {
                        title: '数据日报'
                    }
                },
                {
                    path: '/salaryTemplate',
                    name: 'salaryTemplate',
                    component: () => import('../components/view/salary/salarytemplate/salary_template'),
                    meta: {
                        title: '薪资模版'
                    }
                },
                {
                    path: '/salaryTemplateDetail',
                    name: 'salaryTemplateDetail',
                    component: () => import('../components/view/salary/salarytemplate/salary_template_detail'),
                    meta: {
                        title: '薪资模版详情'
                    }
                },
                {
                    path: '/salaryInfo',
                    name: 'salaryInfo',
                    component: () => import('../components/view/salary/salaryinfo/salary_info'),
                    meta: {
                        title: '薪资管理'
                    }
                },
                {
                    path: '/salaryInfoDetail',
                    name: 'salaryInfoDetail',
                    component: () => import('../components/view/salary/salaryinfo/salary_info_detail'),
                    meta: {
                        title: '薪资管理详情'
                    }
                },
                {
                    path: '/approvalInfo',
                    name: 'approvalInfo',
                    component: () => import('@/components/view/approval/approval_info'),
                    meta: {
                        title: '审批管理'
                    }
                },
                {
                    path: '/giftInfo',
                    name: 'giftInfo',
                    component: () => import('@/components/view/gift/gift_info'),
                    meta: {
                        title: '礼品信息'
                    }
                },
                {
                    path: '/billIn',
                    name: 'billIn',
                    component: () => import('@/components/view/bill/bill_in'),
                    meta: {
                        title: '收款记录'
                    }
                },
                {
                    path: '/billMain',
                    name: 'billMain',
                    component: () => import('@/components/view/bill/bill_main'),
                    meta: {
                        title: '账单主体'
                    }
                },
                {
                    path: '/store',
                    name: 'store',
                    component: () => import('@/components/view/store/store'),
                    meta: {
                        title: '门店'
                    }
                },
                {
                    path: '/storeCategory',
                    name: 'storeCategory',
                    component: () => import('@/components/view/store/store_category'),
                    meta: {
                        title: '商品分类'
                    }
                },
                {
                    path: '/storeTable',
                    name: 'storeTable',
                    component: () => import('@/components/view/store/store_table_main'),
                    meta: {
                        title: '桌台管理'
                    }
                },
                {
                    path: '/storeTableBoard',
                    name: 'storeTableBoard',
                    component: () => import('@/components/view/store/store_table_board'),
                    meta: {
                        title: '桌台看板'
                    }
                },
                {
                    path: '/storeOrder',
                    name: 'storeOrder',
                    component: () => import('@/components/view/store/store_order'),
                    meta: {
                        title: '门店订单'
                    }
                },
                {
                    path: '/storeOrderDetail',
                    name: 'storeOrderDetail',
                    component: () => import('@/components/view/store/store_order_detail'),
                    meta: {
                        title: '门店订单详情'
                    }
                },
                {
                    path: '/orderItem',
                    name: 'orderItem',
                    component: () => import('@/components/view/store/store_order_item'),
                    meta: {
                        title: '订单明细'
                    }
                },
                {
                    path: '/storeSku',
                    name: 'storeSku',
                    component: () => import('@/components/view/store/store_sku'),
                    meta: {
                        title: '门店SKU'
                    }
                },
                {
                    path: '/storeTableType',
                    name: 'storeTableType',
                    component: () => import('@/components/view/store/store_table_type'),
                    meta: {
                        title: '桌台类型'
                    }
                },
                {
                    path: '/billRecord',
                    name: 'billRecord',
                    component: () => import('@/components/view/bill/bill_record'),
                    meta: {
                        title: '账单记录'
                    }
                }
            ],
            meta: {
                parent: '主页',
                title: '主页1'
            }
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js